export var checkStaffDataRange = function (field, staff) {
    var _a;
    if (!field ||
        field.name === 'submitterId' ||
        !staff ||
        (Array.isArray(staff) && !staff.length) ||
        field.allowInteriorStaff === undefined) {
        return staff;
    }
    if (field.allowInteriorStaff && field.allowExternalStaff) {
        return staff;
    }
    if (field.allowInteriorStaff) {
        if (Array.isArray(staff) && ((_a = field === null || field === void 0 ? void 0 : field.defaultValue) === null || _a === void 0 ? void 0 : _a.type) !== 'formula') {
            return staff.filter(function (item) { return !item.external; });
        }
        return staff.external ? undefined : staff;
    }
    if (field.allowExternalStaff) {
        if (Array.isArray(staff)) {
            return staff.filter(function (item) { return item.external; });
        }
        return staff.external ? staff : undefined;
    }
    return staff;
};
